import { t } from '@/i18n';
import { BackendBaseModel } from '@/utils';
import { z } from 'zod';

export const tagType = z.enum(['comment', 'workflow']);

export const tagScopeType = z.enum(['local', 'global']);

export const TagTypeLabelModifier = {
  comment: t('comment'),
  workflow: t('workflow'),
} as const satisfies Record<z.infer<typeof tagType>, string>;

export const TagBaseModel = BackendBaseModel.extend({
  type: tagType,
  name: z.string().min(1).max(16),
  scope: tagScopeType,
});

export const TagTargetBaseModel = z.object({
  objectId: z.string().uuid(),
  tagId: z.string().uuid(),
  tag: TagBaseModel,
});

export const TagsModel = TagBaseModel.extend({
  isTaggable: z.boolean(),
}).array();

export const TagListViewableSchema = z.object({
  startYear: z.number().int().positive().optional(),
  endYear: z.number().int().positive().optional(),
});
